import React, { useMemo } from 'react'
import Select from 'react-select'
import { useMasterData } from '../../utils/useMasterData'

function EditExpenseRegister({ ExpenseRegisterData, sendDataToParent }) {
  const { items: expenseCategoryItems, loading: expenseCategoryLoading } = useMasterData('expenseCategory')

  const expenseCategoryOptions = useMemo(() => {
    return (expenseCategoryItems || []).map((item) => ({
      value: item.MasterValueId.toString(),
      label: item.DisplayName || item.ValueName || '',
      id: item.MasterValueId
    }))
  }, [expenseCategoryItems])

  function handleChange(e) {
    const { name, value } = e.currentTarget
    sendDataToParent({
      ...ExpenseRegisterData,
      [name]: value,
    })
  }

  const selectedExpenseCategory = useMemo(() => {
    if (!ExpenseRegisterData?.ExpenseCategoryId) return null
    const valueStr = ExpenseRegisterData.ExpenseCategoryId.toString()
    return expenseCategoryOptions.find((opt) => opt.value === valueStr) || null
  }, [ExpenseRegisterData?.ExpenseCategoryId, expenseCategoryOptions])

  const handleCategoryChange = (option) => {
    sendDataToParent({
      ...ExpenseRegisterData,
      ExpenseCategoryId: option ? option.value : '',
      ExpenseCategoryName: option ? option.label : ''
    })
  }

  return (
    <>
      <div className="row">
        <input type="hidden" name="ExpenseRegisterId" value={ExpenseRegisterData.ExpenseRegisterId ?? ''} />

        <div className="col-lg-6 mb-3">
          <label className="form-label">Expense Category <span style={{ color: 'red' }}>*</span></label>
          <Select
            classNamePrefix="react-select"
            options={expenseCategoryOptions}
            isLoading={expenseCategoryLoading}
            isClearable
            placeholder="Select expense category"
            value={selectedExpenseCategory}
            onChange={handleCategoryChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Expense Date <span style={{ color: 'red' }}>*</span></label>
          <input
            type="date"
            className="form-control"
            name="ExpenseDate"
            value={ExpenseRegisterData.ExpenseDate ? ExpenseRegisterData.ExpenseDate.split('T')[0] : ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Amount <span style={{ color: 'red' }}>*</span></label>
          <input
            type="number"
            className="form-control"
            name="Amount"
            step="0.01"
            value={ExpenseRegisterData.Amount ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Reference</label>
          <input
            type="text"
            className="form-control"
            name="ReferenceNo"
            value={ExpenseRegisterData.ReferenceNo ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-12 mb-3">
          <label className="form-label">Expense For</label>
          <input
            type="text"
            className="form-control"
            name="ExpenseFor"
            value={ExpenseRegisterData.ExpenseFor ?? ''}
            onChange={handleChange}
          />
          <small className="text-muted">Free text (e.g., employee, department, vendor)</small>
        </div>
        <div className="col-lg-12 mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            rows={4}
            maxLength={600}
            name="Description"
            value={ExpenseRegisterData.Description ?? ''}
            onChange={handleChange}
          />
          <small className="text-muted">Maximum 600 characters</small>
        </div>
      </div>
    </>
  )
}

export default EditExpenseRegister
